import type { GraphQLError } from 'graphql';

export class GraphQLRequestError extends Error {
  public readonly errors: readonly GraphQLError[];

  constructor(errors: readonly GraphQLError[]) {
    super(errors.map((e) => e.message).join('\n'));
    this.name = 'GraphQLRequestError';
    this.errors = errors;
  }
}
